import * as JsCookie from 'js-cookie';
import { CookieStorage, CookieOptions } from '../interfaces';
import { Injectable } from '@angular/core';

@Injectable()
export class JsCookieAdapter implements CookieStorage {
  has(name: string): boolean {
    return JsCookie.get(name) !== undefined;
  }

  get(name: string): string | undefined {
    return JsCookie.get(name);
  }

  set(name: string, value: string, options?: CookieOptions): void {
    const jsOptions: JsCookie.CookieAttributes = options;
    JsCookie.set(name, value, jsOptions);
  }

  remove(name: string, options?: CookieOptions): void {
    const jsOptions: JsCookie.CookieAttributes = options;
    JsCookie.remove(name, jsOptions);
  }
}
